import React from "react";
import { Prompt } from "react-router-dom";
import { useSelector } from "react-redux";

// examStarted: false,
// examEnded: false,

function Prompter() {
  const examEnded = useSelector((state) => state.timer.examEnded);
  const examStarted = useSelector((state) => state.timer.examStarted);

  return (
    <Prompt
      when={examStarted && !examEnded}
      message={(location, action) => {
        return `You sure u want to exit this examination,  ?`;
      }}
    />
  );
}

export default Prompter;
